import React, { useState } from "react";
import axios from "./../../../utils/axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userType, setUserType] = useState("customer"); // 'customer' or 'admin'
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASED_URL}/auth/login`,
        { email, password, userType } // Send userType to the backend
      );
      if (response.status === 200) {
        if (response.data.message === "ADMIN") {
          localStorage.setItem("emailForVerification", email);
          window.location.href = "/administrator";
        } else {
          toast.success(response.data.message);
          // Save email to localStorage
          localStorage.setItem("emailForVerification", email);
          // Redirect based on user type
          window.location.href = `/verifyEmail?userType=${userType}`;
        }
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    }
  };

  const handleForgotPassword = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASED_URL}/auth/forgotPassword`,
        { email }
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        // Save email to localStorage
        localStorage.setItem("emailForVerification", email);
        // Redirect to a confirmation page
        navigate("/verifyEmailForPassword");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    }
  };

  return (
    <div className="container mx-auto flex justify-center items-center h-screen">
      <div className="login__bg h-[92vh] w-[80vh] bg-cover bg-center"></div>
      <div className="w-full md:w-7/12 flex flex-col items-center justify-center">
        {/* User Type Switch */}
        <div className="mb-4">
          <div className="flex justify-center space-x-4">
            <button
              type="button"
              className={`px-4 py-2 rounded ${
                userType === "customer"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-700"
              }`}
              onClick={() => setUserType("customer")}
            >
              Customer
            </button>
            <button
              type="button"
              className={`px-4 py-2 rounded ${
                userType === "admin"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-700"
              }`}
              onClick={() => setUserType("admin")}
            >
              Admin
            </button>
          </div>
        </div>

        <form
          style={{ width: "80%", maxWidth: 500 }}
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              className={`block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500`}
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-sm font-medium mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <input
              type="password"
              className={`block w-full p-2 pl-10 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-green-500 focus:border-green-500`}
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
            />
          </div>
          <div className="flex justify-center mb-4 mt-8">
            <button
              type="submit"
              id="login-btn"
              className="text-white bg-blue-700 hover:bg-blue-800 rounded px-4 py-2"
            >
              Log in
            </button>
          </div>
          <div className="py-4">
            <div className="text-center">
              <small>
                Doesn't have an account ?{" "}
                <Link
                  to={"/register"}
                  className="text-decoration-none text-blue-600 hover:text-blue-800"
                >
                  Sign Up
                </Link>
              </small>
              {/* <div className="my-3">
                <small>OR</small>
              </div> */}
              <div className="d-flex align-items-center justify-content-center">
                <div id="google-signin"></div>
              </div>
            </div>
          </div>
        </form>
        <button className="text-[14px]" onClick={handleForgotPassword}>
          Forgot password?
        </button>
      </div>
    </div>
  );
}

export default Login;
